/**
 * PostHog custom e-commerce events — Artemis Therapeutics
 *
 * Depends on: constants.js, pubsub.js (both load earlier with defer)
 *
 * Events:
 *   product_viewed  — fires once on product pages
 *   article_viewed  — fires once on blog article pages
 *   add_to_cart     — fires on cart update from product form
 *   site_search     — fires on search form submission
 *   email_signup    — fires on blog email capture form submission
 *   article_scroll  — fires at 25/50/75/100% scroll depth on articles
 *   cart_viewed     — fires when cart drawer opens
 */

// --- Product Viewed ---
// Fires a named event on product pages using super properties already set by theme.liquid.
(function () {
  var ph = window.posthog;
  if (!ph) return;
  var pageType = document.querySelector('meta[property="og:type"]');
  if (pageType && pageType.content === 'product') {
    ph.capture('product_viewed');
  }
})();

// --- Add to Cart ---
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event.source !== 'product-form') return;
    window.posthog && posthog.capture('add_to_cart', {
      variant_id: event.productVariantId,
      cart_item_count: event.cartData ? event.cartData.item_count : undefined
    });
  });
}

// --- Cart Viewed (drawer open) ---
(function () {
  // CRO T16: Craft renders <cart-drawer> without an id, so the id lookup never matched
  var drawer = document.getElementById('cart-drawer') || document.querySelector('cart-drawer');
  if (!drawer) return;
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.attributeName === 'class' && drawer.classList.contains('active')) {
        window.posthog && posthog.capture('cart_viewed');
      }
    });
  });
  observer.observe(drawer, { attributes: true });
})();

document.addEventListener('DOMContentLoaded', function () {
  // --- Site Search ---
  var searchForms = document.querySelectorAll('form[action="/search"]');
  searchForms.forEach(function (form) {
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"]');
      var query = input ? input.value.trim() : '';
      if (query && window.posthog) {
        posthog.capture('site_search', { search_query: query });
      }
    });
  });

  // --- Email Signup (blog article form) ---
  var emailForm = document.getElementById('article-email-form');
  if (emailForm) {
    emailForm.addEventListener('submit', function () {
      var input = emailForm.querySelector('input[type="email"]');
      if (input && input.value && window.posthog) {
        posthog.capture('email_signup', {
          source: 'blog_article'
        });
      }
    });
  }

  // --- Article Viewed + Scroll Depth ---
  var articleBody = document.querySelector('.article-template__content');
  if (!articleBody || !window.posthog) return;

  posthog.capture('article_viewed');

  var milestones = [25, 50, 75, 100];
  var fired = {};
  milestones.forEach(function (pct) {
    var sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    sentinel.style.width = '1px';
    sentinel.style.position = 'absolute';
    sentinel.style.left = '0';
    sentinel.style.top = (pct / 100 * articleBody.scrollHeight) + 'px';
    sentinel.setAttribute('data-scroll-pct', pct);
    articleBody.style.position = articleBody.style.position || 'relative';
    articleBody.appendChild(sentinel);
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var pct = parseInt(entry.target.getAttribute('data-scroll-pct'));
      if (!fired[pct]) {
        fired[pct] = true;
        posthog.capture('article_scroll', { scroll_depth: pct });
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0 });

  document.querySelectorAll('[data-scroll-pct]').forEach(function (el) {
    io.observe(el);
  });
});
